import React from 'react';
import PropTypes from 'prop-types';
import StdDropzone from 'react-dropzone';
import { Button, Icon, Dialog, DialogActions, DialogTitle, Tooltip } from '@material-ui/core';
import humanize from 'humanize';
// import { MdPictureAsPdf, MdDeleteForever, MdInsertDriveFile, MdPhotoLibrary, MdRemoveRedEye } from "react-icons/lib/md";

function iconType(type) {
	switch (type.indexOf("image") === 0 ? "image" : type) {
		case "application/pdf":
			return <Icon>picture_as_pdf</Icon>
		case "image":
			return <Icon>image</Icon>
		default:
			return <Icon>file_copy</Icon>
	}
}

export default class Dropzone extends React.Component {
	static propTypes = {
		files: PropTypes.array.isRequired,
		onUpdateFiles: PropTypes.func.isRequired,
		title: PropTypes.string.isRequired,

		allowDuplicate: PropTypes.bool.isRequired,
	}

	static defaultProps = {
		title: 'Clique ou arraste arquivos nesta caixa para anexar.',
		allowDuplicate: false,
	}

	state = {
		dialogs: null,
		mouseFocus: false,
	}

	onMouseEnter = () => this.setState({ mouseFocus: true })

	onMouseLeave = () => this.setState({ mouseFocus: false })

	prepareStyle = () => {
		const { mouseFocus } = this.state;
		return {
			width: '100%',
			marginTop: 10,
			marginBottom: 10,
			padding: 5,
			border: '2px dashed #888',
			backgroundColor: mouseFocus ? '#ccc' : 'inherit',
			cursor: 'pointer',
			boxSizing: 'border-box',
		};
	}

	onDropFiles = (addFiles) => {
		const { files, onUpdateFiles, allowDuplicate } = this.props;
		if (allowDuplicate === false) {
			addFiles = addFiles.filter(newfile => {
				const conflicts = files.filter(f => newfile.name === f.name &&
					newfile.lastModified === f.lastModified &&
					newfile.size === f.size && newfile.type === f.type);
				return conflicts.length === 0;
			});
		}
		onUpdateFiles(files.concat(addFiles));
	}

	previewFile = (file) => {
		const w = window,
			d = document,
			e = d.documentElement,
			g = d.getElementsByTagName('body')[0],
			height = w.innerHeight || e.clientHeight || g.clientHeight;

		const fileURL = URL.createObjectURL(file);

		this.setState({
			dialogs: (
				<Dialog
					open={true}
					onClose={() => this.setState({ dialogs: null })}
					fullWidth
					maxWidth="lg"
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">Visualização do arquivo</DialogTitle>
					<iframe src={fileURL} style={{ width: '100%', height: height - 200, border: 'none' }}></iframe>
					<DialogActions>
						<Button variant="outlined" onClick={() => this.setState({ dialogs: null })} color="default">
							Fechar
						</Button>
					</DialogActions>
				</Dialog>
			),
		});
	}

	render() {
		let {
			files, onUpdateFiles, title,
			allowDuplicate, // eslint-disable-line
			style = {}, ...props,
		} = this.props;
		const { dialogs } = this.state;

		const dropzoneStyle = this.prepareStyle();
		return (
			<div>
				{dialogs}
				<StdDropzone {...props}
					onDrop={this.onDropFiles}
					style={Object.assign({}, dropzoneStyle, style)}
					onMouseEnter={this.onMouseEnter}
					onMouseLeave={this.onMouseLeave}>
					<h5 style={{textAlign:'center',fontSize:'1rem',fontWeight:400}} >{title}</h5>
				</StdDropzone>
				{files.length > 0 ? (
					<ul className="files_list" >
						{files.map((f, index) => {
							return (
								<li key={index}>
									<div className="container_file" >
										<div className="file_icon" >
											{iconType(f.type)}
										</div>
										<div className="file_info" >
											{f.name}
											<small>({humanize.filesize(f.size)})</small>
										</div>
										<Tooltip placement="top" title={window.navigator.msSaveOrOpenBlob ? 'Navegador não possui suporte para visualização,\n recomendado: Mozilla / Chrome / Safari' : 'Visualizar arquivo'}>
											<Button variant="outlined"
													onClick={() => this.previewFile(f)} >
												<Icon>pageview</Icon>
											</Button>
										</Tooltip>
										<Tooltip placement="top" title="Remover" >
											<Button variant="outlined"
												onClick={(ev) => {
													ev.preventDefault();
													files.splice(index, 1);
													onUpdateFiles(files);
												}}>
												<Icon>delete</Icon>
											</Button>
										</Tooltip>
									</div>
								</li>
							);
						})}
					</ul>
				) : null}
				<small>
					{files.length === 0
						? 'Nenhum arquivo selecionado'
						: (files.length === 1
							? '1 arquivo selecionado'
							: `${files.length} arquivos selecionados`)}
				</small>
				<hr style={{ borderColor: '#999', margin: '10px 0' }} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/painel/components/Dropzone/index.js